import { useTranslation } from "@1f/react-sdk";
import { AnagraficaApi } from "../api/anagraficaApi";
import { TIPO_ANAGRAFICA_CLIENTE_PF_KEY, TIPO_ANAGRAFICA_CLIENTE_PG_KEY, TIPO_ANAGRAFICA_LEGALE_RAPP_KEY, TIPO_ANAGRAFICA_PROCURATORE_KEY, TIPO_ANAGRAFICA_TITOLARE_EFFETTIVO_KEY } from "../constants/baseTableKeys";

export const buildAnagraficaSearchFilter = ({ cf, pIva, nome, cognome, denominazione, addrFilter }) => {
    const searchFilter = {};
    const fields = { Cf: cf, PIva: pIva, Nome: nome, Cognome: cognome, Denominazione: denominazione };
    for (const [field, pattern] of Object.entries(fields)) {
        if (pattern != null && String(pattern).replace(/%/g, "").trim() !== "") {
            searchFilter[field] = { _ilike: pattern };
        }
    }
    if (addrFilter && Object.keys(addrFilter).length > 0) {
        searchFilter._and = [addrFilter];
    }
    return searchFilter;
};

export const AnagraficaHelpers = () => {
    const anagApi = AnagraficaApi();
    const { t } = useTranslation();

    const IsAnagraficaCliente = (tipoAnagKey) => {return tipoAnagKey === TIPO_ANAGRAFICA_CLIENTE_PF_KEY || tipoAnagKey === TIPO_ANAGRAFICA_CLIENTE_PG_KEY}
    const IsAnagraficaCollegata = (tipoAnagKey) => {return tipoAnagKey === TIPO_ANAGRAFICA_LEGALE_RAPP_KEY || tipoAnagKey === TIPO_ANAGRAFICA_PROCURATORE_KEY}
    const IsAnagraficaTitolareEffettivo = (tipoAnagKey) => {return tipoAnagKey === TIPO_ANAGRAFICA_TITOLARE_EFFETTIVO_KEY}
    const GetFascicoliCliente = (anagrafica) => {
        return anagrafica.anagraficaFascicoli.filter(
            (x) => x.tipoAnagId === 1 || x.tipoAnagId === 2
        )[0];
    }
    const GetFascicoliCollegate = (anagrafica) => {
        return anagrafica.anagraficaFascicoli.filter(
            (x) => x.tipoAnagId === 3 || x.tipoAnagId === 4
        )[0];
    }
    const GetFascicoliTitolareEffettivo = (anagrafica) => {
        return anagrafica.anagraficaFascicoli.filter(
            (x) => x.tipoAnagId === 5
        )[0];
    }
    const GetTipoCliente = (anagrafica) => {
        if(anagrafica.isPg){
            return isValidCodiceFiscale(anagrafica.cf) ? "DI" : "PG";
        } else {
            return "PF"
        }
    }
    const AnagraficaAlreadyInCollection = (arrayAnagrafiche, anagraficaCf) => {
        return arrayAnagrafiche.length > 0 && arrayAnagrafiche.some((anagrafica) => anagrafica.cf === anagraficaCf);
    }
    const AnagraficaOfSpecifiedTypeNotInCollection = (arrayAnagraficheFascicolo, anagraficaFascicolo) => {
        
        if(anagraficaFascicolo.tipoAnagId === 1 || anagraficaFascicolo.tipoAnagId === 2){
            return arrayAnagraficheFascicolo.filter((x) =>x.tipoAnagId === anagraficaFascicolo.tipoAnagId).length <= 0
        }

        return arrayAnagraficheFascicolo.filter((x) =>
            x.tipoAnagId === anagraficaFascicolo.tipoAnagId &&
            x.tipoAnagId === anagraficaFascicolo.anagraficaId
        ).length <= 0
    }
    const SortVersionAnagrafiche = (arrayAnagrafiche) => {
        return arrayAnagrafiche.sort((a, b) => b.versionN - a.versionN)
    }
    const GetIdFromTipoAnagrafica = (tipoAnagrafica) => {
        switch (tipoAnagrafica) {
            case "cliente":
                return 1;            
            case "collegate":
                return 3;            
            case "titolare":
                return 5;
            default:
                return 0;
        }
    }
    const GetRuoloFromTipoAnagrafica = (tipoAnagrafica) => {
        switch (tipoAnagrafica) {
            case 1:
                return "Cliente Persona Fisica";
            case 2:
                return "Cliente Persona Giuridica";
            case 3:
                return "Legale Rappresentante";            
            case 4:
                return "Procuratore Delegato";
            case 5:
                return "Titolare Effettivo";
            default:
                return 0;
        }
    }
    const CheckAnagraficaBeforeSave = async (anagrafica,anagFascicolo,baseTipoDocList,baseTipoAnagList,clienteAnagType,baseTipoIdentList) => {        
        let errors = [];                 
        try {
            var canIProceed = false;  
            const isTitolareEffettivo = baseTipoAnagList.filter(x => x.id === anagFascicolo.tipoAnagId)[0]?.key === TIPO_ANAGRAFICA_TITOLARE_EFFETTIVO_KEY;
            const isModalitaArt22 = baseTipoIdentList &&
                baseTipoIdentList.filter(x => x.id === anagrafica.modalitaIdentId)[0]?.key === "tipo_identificazione_2";
            const isTitolareArt22 = isTitolareEffettivo && isModalitaArt22;

            if (baseTipoIdentList && isModalitaArt22 && !isTitolareEffettivo) {
                errors.push("Questo tipo di identificazione non è utilizzabile su un'anagrafica che non sia titolare effettivo");
                return errors;
            }

            if (anagrafica.isPg) {
                canIProceed =
                    anagFascicolo.tipoAnagId !== undefined &&
                    anagFascicolo.tipoAnagId > 0 &&
                    anagrafica.cf !== undefined &&
                    anagrafica.cf !== "" &&
                    anagrafica.pIva !== undefined &&
                    anagrafica.pIva !== "" &&
                    anagrafica.denominazione !== undefined &&
                    anagrafica.denominazione !== "" &&                
                    anagrafica.addrPaeseId !== undefined &&
                    anagrafica.addrPaeseId > 0 &&
                    ((anagrafica.addrProvinciaId !== undefined &&
                    anagrafica.addrProvinciaId > 0) ||
                    (anagrafica.addrProvincia !== undefined &&
                        anagrafica.addrProvincia !== "")) &&
                    ((anagrafica.addrComuneId !== undefined &&
                    anagrafica.addrComuneId > 0) ||
                    (anagrafica.addrComune !== undefined &&
                        anagrafica.addrComune !== "")) &&
                    anagrafica.addrIndirizzo !== undefined &&
                    anagrafica.addrIndirizzo !== "" &&
                    anagrafica.addrCap !== undefined &&
                    anagrafica.addrCap !== "" &&
                    anagrafica.modalitaIdentId !== undefined &&
                    anagrafica.modalitaIdentId > 0 &&
                    (isTitolareArt22 || (anagrafica.docTipoId !== undefined &&
                    anagrafica.docTipoId > 0));

                if(clienteAnagType === "DI"){
                    canIProceed = anagrafica.nome && anagrafica.cognome && anagrafica.genereId
                }
            
                let cfVerify = false
                if(clienteAnagType === "DI"){
                    cfVerify = await anagApi.VerifyCf(anagrafica.cf);
                } else if (clienteAnagType === "PG"){
                    cfVerify = await anagApi.VerifyPIva(anagrafica.cf);
                }
                let pIvaVerify = await anagApi.VerifyPIva(anagrafica.pIva);
                if(!cfVerify){
                    canIProceed = false;
                    errors.push("Il codice fiscale inserito non è valido");
                }
                if(!pIvaVerify){
                    canIProceed = false;
                    errors.push("La partita IVA inserita non è valida");
                }               

                if (
                    anagrafica.docTipoId !== undefined &&
                    anagrafica.docTipoId > 0
                ) {
                    if (
                    baseTipoDocList.filter(
                        (x) => x.id === anagrafica.docTipoId
                    )[0].key === "tipo_documento_8"
                    ) {
                    //Data identificazione
                    if (
                        anagrafica.docRilData !== null &&
                        anagrafica.docScad !== null
                    ) {
                        if (
                        new Date(anagrafica.identifiedOn).setHours(
                            0,
                            0,
                            0,
                            0
                        ) >=
                            new Date(anagrafica.docRilData).setHours(
                            0,
                            0,
                            0,
                            0
                            ) &&
                        new Date(anagrafica.identifiedOn).setHours(
                            0,
                            0,
                            0,
                            0
                        ) <=
                            new Date(anagrafica.docScad).setHours(0, 0, 0, 0)
                        ) {
                        } else {
                        canIProceed = false;
                        errors.push(
                            "La data di identificazione deve essere compresa tra la data di rilascio e la data di scadenza del documento"
                        );
                        }
                    }

                    //Data rilascio documento
                    if (
                        new Date(anagrafica.docRilData).setHours(0, 0, 0, 0) >
                        new Date(anagrafica.identifiedOn).setHours(0, 0, 0, 0)
                    ) {
                        canIProceed = false;
                        errors.push(
                        "La data di rilascio deve essere superiore alla data di identificazione"
                        );
                    }

                    //Data scadenza documento
                    if (
                        new Date(anagrafica.docScad).setHours(0, 0, 0, 0) <
                        new Date(anagrafica.docRilData).setHours(0, 0, 0, 0)
                    ) {
                        canIProceed = false;
                        errors.push(
                        "La data di scadenza deve essere superiore alla data di rilascio"
                        );
                    }

                }
                
                }
            
                if(!anagrafica.identifiedByUser){
                    canIProceed = false;
                    errors.push("Il campo identificato da non può essere vuoto");
                }
            } else {
            canIProceed =
                anagFascicolo.tipoAnagId !== undefined &&
                anagFascicolo.tipoAnagId > 0 &&
                anagrafica.cf !== undefined &&
                anagrafica.cf !== "" &&
                anagrafica.nome !== undefined &&
                anagrafica.nome !== "" &&
                anagrafica.cognome !== undefined &&
                anagrafica.cognome !== "" &&
                anagrafica.professione !== undefined &&
                anagrafica.professione !== "" &&
                anagrafica.nascitaLuogo !== undefined &&
                anagrafica.nascitaLuogo !== "" &&
                anagrafica.nascitaData !== undefined &&
                anagrafica.nascitaData !== null &&
                anagrafica.addrPaeseId !== undefined &&
                anagrafica.addrPaeseId > 0 &&
                ((anagrafica.addrProvinciaId !== undefined &&
                anagrafica.addrProvinciaId > 0) ||
                (anagrafica.addrProvincia !== undefined &&
                    anagrafica.addrProvincia !== "")) &&
                ((anagrafica.addrComuneId !== undefined &&
                anagrafica.addrComuneId > 0) ||
                (anagrafica.addrComune !== undefined &&
                    anagrafica.addrComune !== "")) &&
                anagrafica.addrIndirizzo !== undefined &&
                anagrafica.addrIndirizzo !== "" &&
                anagrafica.addrCap !== undefined &&
                anagrafica.addrCap !== "" &&
                anagrafica.modalitaIdentId !== undefined &&
                anagrafica.modalitaIdentId > 0 &&
                (isTitolareArt22 || (anagrafica.docTipoId !== undefined &&
                anagrafica.docTipoId > 0));

            if (
                (baseTipoAnagList.filter(
                (x) => x.id === anagFascicolo.tipoAnagId
                )[0].key === TIPO_ANAGRAFICA_TITOLARE_EFFETTIVO_KEY || anagFascicolo.tipoAnagId === 5) &&
                (!anagFascicolo.tipoPartId || anagFascicolo.tipoPartId <= 0)
            ) {
                canIProceed = false;
            }

            let cfVerify = await anagApi.VerifyCf(anagrafica.cf);
            if(!cfVerify){
                canIProceed = false;
                errors.push("Il codice fiscale inserito non è valido");
            }

            //Data identificazione
            if (
                !isTitolareArt22 &&
                anagrafica.docRilData !== null &&
                anagrafica.docScad !== null
            ) {
                if (
                new Date(anagrafica.identifiedOn).setHours(
                    0,
                    0,
                    0,
                    0
                ) >=
                    new Date(anagrafica.docRilData).setHours(
                    0,
                    0,
                    0,
                    0
                    ) &&
                new Date(anagrafica.identifiedOn).setHours(
                    0,
                    0,
                    0,
                    0
                ) <= new Date(anagrafica.docScad).setHours(0, 0, 0, 0)
                ) {
                } else {
                canIProceed = false;
                errors.push(
                    "La data di identificazione deve essere compresa tra la data di rilascio e la data di scadenza del documento"
                );
                }
            }

            //Data rilascio documento
            if (
                !isTitolareArt22 &&
                new Date(anagrafica.docRilData).setHours(0, 0, 0, 0) >
                new Date(anagrafica.identifiedOn).setHours(0, 0, 0, 0)
            ) {
                canIProceed = false;
                errors.push(
                "La data di rilascio deve essere superiore alla data di identificazione"
                );
            }

            //Data scadenza documento
            if (
                !isTitolareArt22 &&
                new Date(anagrafica.docScad).setHours(0, 0, 0, 0) <
                new Date(anagrafica.docRilData).setHours(0, 0, 0, 0)
            ) {
                canIProceed = false;
                errors.push(
                "La data di scadenza deve essere superiore alla data di rilascio"
                );
            }

            if(anagrafica.isPep && !anagrafica.pepRuolo){
                canIProceed = false;
                errors.push("Il campo carica politica ricoperta non può essere vuoto se l'anagrafica è un PEP");
            }

            if(!anagrafica.identifiedByUser){
                canIProceed = false;
                errors.push("Il campo identificato da non può essere vuoto");
            }

            if(!isAFiscalCode(anagrafica.cf)){
                canIProceed = false;
                errors.push("Il codice fiscale inserito non è valido");
            }
            }

            if (!canIProceed && errors.length <= 0) {
                errors.push(t("error.missingFields"));
            }

            return errors;
        } catch (e) {
            throw new Error("Errore durante il controllo dell'anagrafica: " + e.message);
        }        
    }   
    const MergeDefined = (base,override) => {
        const result = {};
        for (const key in base) {
            result[key] = override[key] !== undefined ? override[key] : base[key];
        }
        return result
    }
    const CompareAnagrafiche = (anagrafica1, anagrafica2) => {
        const keysToCompare = [
            "addr2Cap","addr2Comune","addr2ComuneId","addr2Indirizzo",
            "addr2N","addr2PaeseId","addr2Provincia","addr2ProvinciaId","addrCap",
            "addrComune","addrComuneId","addrIndirizzo","addrN",
            "addrPaeseId","addrProvincia","addrProvinciaId","amlId","anagraficaId",
            "apCf","apNome","capSociale","cf","cognome","countryCode","createdBy",
            "createdOn","denominazione","descAttivita","docN","docRilDa","docRilData",
            "docScad","docTipoId","errWs","errWsNote","expiryDate","genereId","id",
            "identifiedByUser","identifiedOn","importDesc","isDeleted","isNotPepMoreThanYear",
            "isPep","isPg","modalitaIdentId","modifiedBy","modifiedOn","nascitaData","nascitaLuogo",
            "nome","office1Id","office2Id","orgAmmin","parentId","pepCarica","pepRuolo",
            "pIva","professione","reaComune","reaN","revisionWs","status","tenantId",
            "tipoPatrimonioAltro","tipoPatrimonioId","tipoRedditoAltro","tipoRedditoId",
            "versionDate","versionN","atecoCode","attivitaLavDescr"
        ];
        for (const key of keysToCompare) {
            if (anagrafica1[key] !== anagrafica2[key]) {
                return false;
            }
        }
        return true;
    }
    const GetTipoAnagFromOptions = (tipoAnag) => {
        switch (tipoAnag) {
            case "Cliente Persona fisica":
                return "cliente";
            case "Cliente Persona giuridica":
                return "cliente";
            case "Legale rappresentante":
                return "collegate";
            case "Procuratore delegato":
                return "collegate";
            case "Titolare effettivo":
                return "titolare";
            default:
                return "cliente";
        }
    }
    const FindDifferentFields = (duplicates) => {
        if (!duplicates || duplicates.length < 2) {
            return new Set();
        }
        
        const differentFields = new Set();
        const reference = duplicates[0];
        
        // Normalizza il valore: tratta stringhe vuote e null come equivalenti
        const normalizeValue = (value,fieldName) => {
            if (value === null || value === undefined || value === '') {
                return null;
            }
             // Se il campo è un ID e il valore è 0, normalizzalo a null
            if (fieldName.toLowerCase().includes('id') && value === 0) {
                return null;
            }
            return value;
        };
        
        // Campi da confrontare
        const fieldsToCompare = [
            'nome', 'cognome', 'denominazione', 'cf', 'pIva',
            'nascitaData', 'nascitaLuogo', 'professione',
            'addrIndirizzo', 'addrN', 'addrComuneId', 'addrProvinciaId', 'addrCap',
            'modalitaIdentId', 'docTipoId', 'docN', 'docRilDa', 'docRilData', 'docScad',
            'identifiedByUser', 'identifiedOn', 'isPep', 'versionN', 'modifiedOn'
        ];
        
        duplicates.forEach((duplicate, index) => {
            if (index === 0) return; // Salta il riferimento
            
            fieldsToCompare.forEach(field => {
                const refValue = normalizeValue(reference[field],field);
                const dupValue = normalizeValue(duplicate[field],field);
                
                // Confronta i valori normalizzati
                if (refValue !== dupValue) {
                    // Gestione speciale per le date
                    if (field.includes('Data') || field === 'identifiedOn' || field === 'modifiedOn') {
                        const refDate = refValue ? new Date(refValue).getTime() : null;
                        const dupDate = dupValue ? new Date(dupValue).getTime() : null;
                        
                        if (refDate !== dupDate) {
                            differentFields.add(field);
                        }
                    } else {
                        differentFields.add(field);
                    }
                }
            });
        });
        
        return differentFields;
    };
    const FromRappIdToRappDesc = (tipoRappId) => {
        switch (tipoRappId) {
            case 0:
                return "MANDATO_CON_RAPPRESENTANZA";
            case 1:
                return "MANDATO_SENZA_RAPPRESENTANZA";
            case 2:
                return "ALTRO";
            default:
                return "MANDATO_CON_RAPPRESENTANZA";
        }
    }
    const CountRischioGeograficoCategoryFromArray = (anagrafiche, paesi, province) => {
        let rischioGeo1 = 0;
        let rischioGeo2 = 0;
        let rischioGeo3 = 0;
        let rischioGeo4 = 0;

        for (let i = 0; i < anagrafiche.length; i++) {
            const anagrafica = anagrafiche[i];
            if(anagrafica.AddrPaeseId === null || anagrafica.AddrPaeseId <= 0 ) continue;            
            
            const country = paesi.find((x) => x.id === anagrafica.AddrPaeseId) || null;
            if(!country) continue;

            if (country.identificativo === "ITA") {                
                const provincia = province.find((x) => x.id === anagrafica.AddrProvinciaId) || null;
                if(!provincia) continue;
                switch (provincia.rischio) {
                    case 1: {
                        rischioGeo1 ++;
                        break;
                    }
                    case 2: {
                        rischioGeo2 ++;
                        break;
                    }
                    case 3: {
                        rischioGeo3 ++;
                        break;
                    }
                    case 4: {
                        rischioGeo4 ++;
                    break;
                    }
                    default:
                        break;
                }                                                                    
            } else {
                rischioGeo4 ++;
            }  
        }
        return {rischioGeo1,rischioGeo2,rischioGeo3,rischioGeo4};
    }
    const CountPPECategoryFromArray = (anagrafiche) => {
        let ppe1 = 0;
        let ppe2 = 0;
        let ppe3 = 0;
        for (let i = 0; i < anagrafiche.length; i++) {
            const anagrafica = anagrafiche[i];
            if (anagrafica.IsPep) {
                ppe1 ++;
            } else { 
                if (!anagrafica.IsNotPepMoreThanYear) {
                    ppe2 ++;
                } else if (anagrafica.IsNotPepMoreThanYear) {
                    ppe3 ++;
                }
            }
        }
        return {ppe1,ppe2,ppe3};
    }
    return{    
        IsAnagraficaCliente,
        IsAnagraficaCollegata,
        IsAnagraficaTitolareEffettivo,
        AnagraficaAlreadyInCollection,
        AnagraficaOfSpecifiedTypeNotInCollection,
        SortVersionAnagrafiche,
        GetFascicoliCliente,
        GetFascicoliCollegate,
        GetFascicoliTitolareEffettivo,
        GetIdFromTipoAnagrafica,
        CheckAnagraficaBeforeSave,
        MergeDefined,
        GetRuoloFromTipoAnagrafica,
        CompareAnagrafiche,
        GetTipoCliente,
        GetTipoAnagFromOptions,
        FindDifferentFields,
        FromRappIdToRappDesc,
        CountRischioGeograficoCategoryFromArray,
        CountPPECategoryFromArray
    }
}

// Export standalone functions for backward compatibility
export const getDataFromFiscalCode = (fiscalCode) => {
    if (fiscalCode === "" || fiscalCode.length < 16 || fiscalCode.length > 16) {
        return "";
    }

    var annoLasPart = fiscalCode.substring(6, 8);

    var anno = "19" + annoLasPart;
    if (
        parseInt(annoLasPart) >= 0 &&
        parseInt("20" + annoLasPart) <= new Date().getFullYear()
    ) {
        anno = "20" + annoLasPart;
    }
    var mese = fiscalCode.substring(8, 9);
    var giorno = fiscalCode.substring(9, 11);
    var codComune = fiscalCode.substring(11, 15);
    var sesso = "M";

    var giornoN = parseInt(giorno);
    if (giornoN > 40) {
        giorno = (giornoN - 40).toString();
        sesso = "F";
    }

    giorno = giorno.length === 1 ? "0" + giorno : giorno;

    switch (mese) {
        case "A": {
            mese = "01";
            break;
        }
        case "B": {
            mese = "02";
            break;
        }
        case "C": {
            mese = "03";
            break;
        }
        case "D": {
            mese = "04";
            break;
        }
        case "E": {
            mese = "05";
            break;
        }
        case "H": {
            mese = "06";
            break;
        }
        case "L": {
            mese = "07";
            break;
        }
        case "M": {
            mese = "08";
            break;
        }
        case "P": {
            mese = "09";
            break;
        }
        case "R": {
            mese = "10";
            break;
        }
        case "S": {
            mese = "11";
            break;
        }
        case "T": {
            mese = "12";
            break;
        }
        default: {
            mese = 0;
            break;
        }
    }

    return {
        data: giorno + "/" + mese + "/" + anno,
        sesso: sesso,
        codComune: codComune,
    };
}
export const isPIvaValid = (pIva) => {
    if (pIva === "") {
        return "";
    }

    if (pIva.length !== 11) {
        return "La lunghezza della partita IVA non è corretta: la partita IVA dovrebbe essere lunga esattamente 11 caratteri.";
    }

    const validi = "0123456789";
    for (let i = 0; i < 11; i++) {
        if (validi.indexOf(pIva.charAt(i)) === -1)
            return (
                "La partita IVA contiene un carattere non valido `" +
                pIva.charAt(i) +
                "'. I caratteri validi sono le cifre."
            );
    }

    let s = 0;

    for (let i = 0; i <= 9; i += 2) {
        s += pIva.charCodeAt(i) - "0".charCodeAt(0);
    }

    for (let i = 1; i <= 9; i += 2) {
        let c = 2 * (pIva.charCodeAt(i) - "0".charCodeAt(0));
        if (c > 9) {
            c = c - 9;
        }
        s += c;
    }

    if ((10 - (s % 10)) % 10 !== pIva.charCodeAt(10) - "0".charCodeAt(0)) {
        return "La partita IVA non è valida: il codice di controllo non corrisponde.";
    }

    return "";
}
export const isFiscalCodeValid = (firstName, secondName, sex, birthDate, birthPlace, comuni, paesi) => {
    const months = {
        0: 'A', 1: 'B', 2: 'C', 3: 'D', 4: 'E', 5: 'H',
        6: 'L', 7: 'M', 8: 'P', 9: 'R', 10: 'S', 11: 'T'
    };

    const oddMap = {
        '0': 1, '1': 0, '2': 5, '3': 7, '4': 9, '5': 13, '6': 15, '7': 17, '8': 19, '9': 21,
        'A': 1, 'B': 0, 'C': 5, 'D': 7, 'E': 9, 'F': 13, 'G': 15, 'H': 17, 'I': 19, 'J': 21,
        'K': 2, 'L': 4, 'M': 18, 'N': 20, 'O': 11, 'P': 3, 'Q': 6, 'R': 8, 'S': 12,
        'T': 14, 'U': 16, 'V': 10, 'W': 22, 'X': 25, 'Y': 24, 'Z': 23
    };

    const evenMap = {
        '0': 0, '1': 1, '2': 2, '3': 3, '4': 4, '5': 5, '6': 6, '7': 7, '8': 8, '9': 9,
        'A': 0, 'B': 1, 'C': 2, 'D': 3, 'E': 4, 'F': 5, 'G': 6, 'H': 7, 'I': 8, 'J': 9,
        'K': 10, 'L': 11, 'M': 12, 'N': 13, 'O': 14, 'P': 15, 'Q': 16, 'R': 17, 'S': 18,
        'T': 19, 'U': 20, 'V': 21, 'W': 22, 'X': 23, 'Y': 24, 'Z': 25
    };

    const controlCodeChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

    function extractConsonants(str) {
        return str.replace(/[^BCDFGHJKLMNPQRSTVWXYZ]/gi, '');
    }

    function extractVowels(str) {
        return str.replace(/[^AEIOU]/gi, '');
    }

    function padCode(code) {
        return code.padEnd(3, 'X');
    }

    function getNameCode(name) {
        const cons = extractConsonants(name.toUpperCase());
        if (cons.length >= 4) {
            return cons[0] + cons[2] + cons[3];
        } else {
            const vow = extractVowels(name.toUpperCase());
            return padCode((cons + vow).slice(0, 3));
        }
    }

    function getSurnameCode(surname) {
        const cons = extractConsonants(surname.toUpperCase());
        const vow = extractVowels(surname.toUpperCase());
        return padCode((cons + vow).slice(0, 3));
    }

    function getDateCode(birthDate, sex) {
        let birth = new Date(birthDate)
        const year = birth.getFullYear();
        const month = birth.getMonth();
        const day = birth.getDate();
        const yearCode = year.toString().slice(-2);
        const monthCode = months[month];
        const dayCode = sex === 2 ? day + 40 : day;
        return yearCode + monthCode + String(dayCode).padStart(2, '0');
    }

    function getPlaceCode(place, comuni, paesi) {
        if (comuni.filter(x => x.Nome.toLowerCase() === place.toLowerCase()).length > 0) return comuni.filter(x => x.Nome.toLowerCase() === place.toLowerCase())[0].CodBelfiore;
        if (paesi.filter(x => x.Nome.toLowerCase() === place.toLowerCase()).length > 0) return paesi.filter(x => x.Nome.toLowerCase() === place.toLowerCase())[0].CodiceAt;
        throw new Error(`Codice catastale non trovato per: ${place}`);
    }

    function getControlChar(code) {
        let sum = 0;
        for (let i = 0; i < 15; i++) {
            const c = code[i].toUpperCase();
            sum += (i % 2 === 0) ? oddMap[c] : evenMap[c];
        }
        return controlCodeChars[sum % 26];
    }

    const code =
        getSurnameCode(secondName) +
        getNameCode(firstName) +
        getDateCode(birthDate, sex) +
        getPlaceCode(birthPlace, comuni, paesi);

    const controlChar = getControlChar(code);
    return code + controlChar;
}
export const isGuid = (guid) => {
    const guidPattern =
        /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[4][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$/;
    return guidPattern.test(guid);
}
export const isAFiscalCode = (fiscalCode) => {
    let isFiscalCode = fiscalCode.match(
        /^([A-Z]{6}[0-9LMNPQRSTUV]{2}[ABCDEHLMPRST]{1}[0-9LMNPQRSTUV]{2}[A-Z]{1}[0-9LMNPQRSTUV]{3}[A-Z]{1})$|([0-9]{11})$/
    );
    return isFiscalCode !== null;
}
export const isValidCodiceFiscale = (cf) => {
    if (typeof cf !== 'string') return false;

    // Converte il codice in maiuscolo
    cf = cf.toUpperCase();

    // Controlla la lunghezza e il formato (16 caratteri alfanumerici)
    const regex = /^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][0-9]{3}[A-Z]$/;
    if (!regex.test(cf)) return false;

    return true;
}
export const isNumericEU_VAT = (vatNumber) => {
    // Lista delle lunghezze valide delle partite IVA nei paesi membri dell'UE
    const validLengths = [11];
    // Controlla se la partita IVA è composta solo da cifre e se la lunghezza è valida
    const isNumeric = /^\d+$/.test(vatNumber);
    const isValidLength = validLengths.includes(vatNumber.length);

    return isNumeric && isValidLength;
}
export const isValidItalianVAT = (partitaIVA) => {
    // Controlla che la partita IVA sia composta da 11 cifre
    if (!/^\d{11}$/.test(partitaIVA)) {
        return false;
    }

    let s = 0;
    for (let i = 0; i < 11; i++) {
        let n = parseInt(partitaIVA.charAt(i), 10);
        if ((i + 1) % 2 === 0) {
            n = n * 2;
            if (n > 9) {
                n = n - 9;
            }
        }
        s += n;
    }

    return s % 10 === 0;
}

export default AnagraficaHelpers;